<template lang="pug">
  main
    NavBar
    Loader(v-show="isLoading")
    section.section
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h3.title SCA TPA&nbsp
              a.button.is-dark.is-rounded(@click="backPage")
                  i.fas.fa-times
        .columns
          .column.is-2
            a.button.is-black(@click="registrarTanque")
              | Nueva Entrada
          .column.is-1
            label.label Fecha:
          .column.is-2
            .field
              .control
                flat-pickr(
                  v-model='fechaJornada'
                  :config="config"
                  class="input"
                )
          .column.is-1
            a.button.is-black.is-rounded.is-small(@click="iniciarComponente")
              span.icon
                i.fas.fa-sync
          .column.is-offset-2.is-1
            .field
              label.label Filtrar
          .column.is-3
              .control
                input.input.is-primary(
                  type='text',
                  placeholder='Buscar por PG | Fecha | Grupo | Subgrupo',
                  v-model="query_filter",
                )
        .columns
          .column.is-12
            .table-responsive
              table#Ingresos.table.is-striped.is-fullwidth
                thead
                  tr
                    th.is-size-6
                      | #
                    th.is-size-6
                      | Autotanque
                    th.is-size-6
                      | Registrado
                    th.is-size-6
                      | Salida
                tbody
                  tr(v-for="(emb, index) in embarques" :key="emb.id")
                    td(:class="emb.estado == 3 ? 'is-warning' : ''")
                      a.button.is-black.is-rounded.is-small(@click="emb.estado !=3 ? editarRegistro(emb.claveAcceso): ''")
                        | {{ index + 1 }}
                    td(:class="emb.estado == 3 ? 'is-warning' : ''")
                      span.tag.is-black
                        | {{ emb.pg }}
                      | &nbsp
                      a.button.is-danger.is-small.is-rounded(v-show="emb.estado != 3" @click="eliminarRegistro(emb.id, emb.pg)")
                        span.icon
                          i.fas.fa-trash
                    td(:class="emb.estado == '3' ? 'is-warning' : ''")
                      a.button.is-warning.is-rounded.is-small(v-if="emb.estado == '0' && emb.fechaLlegada == null " @click="registrarAcceso(emb.claveAcceso)")
                        | Programado
                      span(v-else).tag
                        | {{ emb.fechaLlegada }}
      .columns.column-blanco
</template>

<script>
  import NavBar from './layout/NavBar'
  import Loader from '@/components/shared/Loader.vue'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import { mapState } from 'vuex'
  import moment from 'moment'
  import accesos_tpaServices from '@/services/sca/accesos/accesosTPA.js'

  export default {
    name: 'HomeAcceso',
    components: { NavBar, Loader, flatPickr },
    data() {
      return {
        cambiosRealizados: '',
        isLoading: true,
        query_filter: '',
        fechaJornada: this.getFechaJornada(),
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Spanish, // locale for this instance only
        },
        verReporte: false,
        embarques: []
      }
    },
    watch: {
      fechaJornada() {
        this.obtenerTanquesLlegando()
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerTanquesLlegando()
      },
      obtenerTanquesLlegando() {
        accesos_tpaServices.getAccesos(this.fechaJornada)
          .then( data => {
            this.embarques = data.map(this.convertirAcceso)
            this.isLoading = false
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
          })
      },

      convertirAcceso(acc) {
        return {
          ...acc,
          id: parseInt(acc.id),
          estado: parseInt(acc.estado),
          embarque: parseInt(acc.embarque),
          pesoEntrada: Number(acc.pesoEntrada),
          pesoSalida: Number(acc.pesoSalida)
        }
      },


      registrarAcceso(claveAcceso) {
        if (this.permisos.sca_tpa != 3) {
          return
        }

        accesos_tpaServices.registrarAcceso_clave(claveAcceso)
        .then( data => {
          console.log("🚀 ~ file: HomeAccesos.vue:154 ~ registrarAcceso ~ data:", data)
          if (data.success) {
            this.displayToast('toasted-primary', `${data.respuesta}`, 'info', 'OK')
            this.iniciarComponente()
          } else {
            this.displayToast('bubble', `Error: ${data.respuesta}`, 'ban', 'OK')
          }
        })
        .catch( e => {
          this.displayToast('bubble', `Error: ${e.message}`, 'ban', 'Ok')
          this.isLoading = false
        })

      },

      editarRegistro (claveAcceso) {
        if (this.permisos.sca_tpa != 3) {
          return
        }
        const accesos = this.embarques.filter( emb => emb.claveAcceso === claveAcceso)
        const accesosSorted = accesos.sort( (a, b) => a.id - b.id)
        this.$store.commit('editarAccesoTpa', accesosSorted)
        this.$router.push('/TPA/SCA/Accesos/Editar')
      },

      eliminarRegistro (id, pg) {
        if (this.permisos.sca_tpa != 3) {
          return
        }
        this.isLoading = true
        accesos_tpaServices.deleteAcceso(id)
          .then( data => {
            let ahora = moment().format('hh:mm:ss')
            this.cambiosRealizados = `Solicitud para eliminar acceso PG: ${pg}. Hora: ${ahora}.`
            this.registrarMovimiento(this.cambiosRealizados)
            this.displayToast('toasted-primary', data.respuesta, data.success ? 'check' : 'ban', 'Ok')
            this.displayToast('toasted-primary', 'Se le será notificado a los administradores', 'done', 'OK')
            this.isLoading = true
            this.obtenerTanquesLlegando()
          })
          .catch( e => {
            this.displayToast('bubble', `Error: ${e.message}`, 'ban', 'Ok')
            this.isLoading = false
          })
      },

      displayToast(tema, text, icon, actionText) {
        let toast = this.$toasted.show(text, {
          theme: tema,
          position: "bottom-right",
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },

      backPage() {
        this.$router.back()
      },

      getFechaJornada() {
        let ahora = moment().format('YYYY-MM-DD HH:mm:ss')
        let hoy = moment()
        let ahoraFinal = moment('05:30am', 'h:mma')
        if (ahoraFinal.isBefore(ahora)) {
          return hoy.format('YYYY-MM-DD')
        } else {
          return hoy.subtract(1, 'days').format('YYYY-MM-DD')
        }
      },

      registrarTanque() {
        if (this.permisos.sca_tpa == 3) {
          this.$router.push('/TPA/SCA/Accesos/Registrar')
        }
      },

      registrarMovimiento(cambios){
        accesos_tpaServices.addEdicion('N/A', moment().format('YYYY-MM-DD'), this.userLogin.nombre, cambios, 'Solicitud de eliminar acceso')
          .then( data => {
            console.log('Cambios registrados')
          })
          .catch( e => {
            this.displayToast('bubble', `Error: ${e.message}`, 'ban', 'Ok')
            this.isLoading = false
          })
      },
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['logueado', 'userLogin', 'permisos'])
    }
  }
</script>

<style lang="scss" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/sca_Componentes/tpa/accesos/HomeAccesos.vue